<div class="skeleton" aria-busy="true" aria-label="Loading conversion metrics">
  <ngx-skeleton-loader
    class="skeleton__card"
    *ngFor="let card of cards; trackBy: trackByIndex"
    count="1"
    appearance="line"
    [theme]="cardTheme"
  ></ngx-skeleton-loader>
</div>
